import { ArraySeriesType, PointSeriesType } from '..';

/**
 * Transforms an array of array points to an array of object points
 * @param series series with array points
 * @returns series with object points
 */
export const transformArrayPoints = (series: ArraySeriesType): PointSeriesType => {
  return {
    ...series,
    data: series?.data?.map(([ts, ...v]) => {
      return {
        x: ts,
        ...(v.length === 1 ? { y: v[0] } : { low: v[0], high: v[1] }),
      };
    }),
  } as PointSeriesType;
};
